import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as Cancel } from '../../../../../assets/icons/close.svg'
import { ReactComponent as Save } from '../../../../../assets/icons/save.svg'
import {
    IResponseContent,
    useResponsesStore,
} from '../../../../../stores/responsesStore'
import CustomMonacoEditor from '../../../../MonacoSection/CustomMonacoEditor/CustomMonacoEditor'

import styles from './response-yaml-editor.module.scss'

interface IResponseYamlEditor {
    message: IResponseContent
    closePopup: () => void
}

function ResponseYamlEditor(props: IResponseYamlEditor) {
    const { message, closePopup } = props

    const { t } = useTranslation()

    const [, { editResponseYaml }] = useResponsesStore()

    const [responseData, setResponseData] = useState(message.yaml || '')

    const handleEditorChange = (data: string | undefined) => {
        if (!data) return
        setResponseData(data)
    }

    const handleSave = async () => {
        await editResponseYaml({ ...message, yaml: responseData })
        closePopup()
    }

    const handleCancel = () => {
        setResponseData(message.yaml || '')
        closePopup()
    }

    return (
        <div className={styles.responseYamlEditor}>
            <div className={styles.responseYamlEditor__head}>
                <button
                    className={styles.responseYamlEditor__btn}
                    onClick={handleSave}
                >
                    <Save
                        className={styles.responseYamlEditor__icon}
                        alt={t('save')}
                    />
                </button>
                <button
                    className={styles.responseYamlEditor__btn}
                    onClick={handleCancel}
                >
                    <Cancel
                        className={styles.responseYamlEditor__icon}
                        alt={t('cancel')}
                    />
                </button>
            </div>
            <CustomMonacoEditor
                handleEditorChange={handleEditorChange}
                value={responseData}
                className={styles.responseYamlEditor__}
                isThemeDark
            />
        </div>
    )
}

export default ResponseYamlEditor
